'use strict';

var template = require('../../templates/reports/EmployeeTotals.ejs');
var moment   = require('moment');
import Report from 'newModels/report.js';

module.exports = Backbone.View.extend({
    events: {
        'submit form.filters':             'filter',
        'changeDate .js-datepicker-range': 'taint',
        'change input, select':            'taint',
        'change .js-date-range':           'updateDatepickers',
        'change .js-group-by':             'updateGroupBy',
        'change .js-type':                 'updateType',
        'change .js-datepicker-from':      'updateFromDate',
        'change .js-datepicker-to':        'updateToDate',
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            employees: [],
            locations: [],
            filters:   {
                'dateRange':  null,
                'from':       null,
                'to':         null,
                'group[]':    null,
                'groupBy':    null,
                'type':       null
            },
            totals: [],
            grandTotal: null,
            fromPeriod: '',
            toPeriod: ''
        });

        this.getGroupBy();

        if (
            this.options.filters.dateRange === this.options.filters.from &&
            this.options.filters.dateRange === this.options.filters.to
        ) {
            this.options.filters.dateRange = 'everything';
            this.options.filters.from      = this.options.fromPeriod;
            this.options.filters.to        = this.options.toPeriod;
        }

        return this.render();
    },

    render: function() {
        _.each(['from', 'to'], function(key) {
            if (this.options.filters[key] instanceof Date) {
                this.options.filters[key + 'Formatted'] = moment(
                    this.options.filters[key]
                ).format('MMMM, YYYY');
            }
        }.bind(this));

        this.$el.html(template({
            group:      this.group,
            dateRanges: this.getDateRanges(),
            filters:    this.options.filters,
            rows:       this.options.totals,
            rowCount:   this.options.totals.length || 0,
            types: [
                'Total',
                'PCB',
                'EPF',
                'SOCSO',
                'EIS',
                'HRDF',
                'Zakat',
                'Additions',
                'Deductions'
            ],
            groupBy: [
                'Employee',
                'Location'
            ],
            grandTotal:     this.options.grandTotal
        }));

        this.$('.js-datepicker-range').datepicker({
            keyboardNavigation: false,
            forceParse:         false,
            autoclose:          true,
            todayBtn:           'linked',
            format:             'MM, yyyy',
            viewMode:           'months',
            minViewMode:        'months'
        });
        this.$('.chosen-select').chosen({width: '275px'});
        this.$('.footable').footable();
        const type = (this.options.filters.type || 'total').toLowerCase();
        //very crazy logic to hide columns in report,
        //should be easier if we use HTML 5 at least if divs and flex/grid css
        if (type !== 'total') {
            const half = {width: '50%'};
            this.$('.js-rows td').not(`[name=${type}]`).hide();
            this.$('.js-rows td[name=fullname]').show();
            this.$(`.js-rows td[name=${type}]`).css(half);

            this.$('.second-header th').not(`[name=${type}]`).hide();
            this.$('.second-header th[name=fullname]').show();
            this.$(`.second-header th[name=${type}]`).css(half);

            this.$('.first-header th').not(`[name=${type}]`).hide();
            this.$('.first-header th[name=fullname]').show();
            this.$(`.first-header th[name=${type}]`).css(half);

            this.$('.employee-total td').not(`[name=${type}]`).hide();
            this.$('.employee-total td[name=fullname]').show();
            this.$(`.employee-total td[name=${type}]`).css(half);
        }
        this.$('.js-rows [name=fullname]').on('click', ev => {
            this.$(ev.currentTarget)
                .parent()
                .find('.details')
                .toggleClass('hidden');
        });

        if (this.options.filters.dateRange === 'everything') {
            var $from   = this.$('.js-datepicker-from');
            var $to     = this.$('.js-datepicker-to');
            $from.datepicker('setDate', this.options.fromPeriod.toDate());
            $to.datepicker('setDate', this.options.toPeriod.toDate());
        }

        this.updateDownloadLink();
    },

    momentStartOf: function(what) {
        return moment().startOf(what).add(1, 'days');
    },

    momentEndOf: function(what) {
        return moment().endOf(what);
    },

    getDateRanges: function() {
        return {
            'current_month': {
                label: 'Current Month',
                from:  this.momentStartOf('month'),
                to:    this.momentEndOf('month')
            },
            'last_month': {
                label: 'Last Month',
                from:  this.momentStartOf('month').subtract(1, 'month'),
                to:    this.momentStartOf('month').subtract(1, 'month')
                    .endOf('month')
            },
            'current_quarter': {
                label: 'Current Quarter',
                from:  this.momentStartOf('quarter'),
                to:    this.momentEndOf('quarter')
            },
            'last_quarter': {
                label: 'Last Quarter',
                from:  this.momentStartOf('quarter').subtract(1, 'quarter'),
                to:    this.momentStartOf('quarter').subtract(1, 'quarter')
                    .endOf('quarter')
            },
            'current_year': {
                label: 'Current Year',
                from:  this.momentStartOf('year'),
                to:    this.momentEndOf('year')
            },
            'last_year': {
                label: 'Last Year',
                from:  this.momentStartOf('year').subtract(1, 'year'),
                to:    this.momentStartOf('year').subtract(1, 'year')
                    .endOf('year')
            },
            'sign_up': {
                label: 'Since Signing Up',
                from:  moment(app.company.get('createdAt')),
                to:    moment(app.company.get('createdAt')).add(1, 'year')
            }
        };
    },

    updateDatepickers: function(ev) {
        var $select = this.$(ev.currentTarget);
        var $option = $select.find(':selected');
        var $from   = this.$('.js-datepicker-from');
        var $to     = this.$('.js-datepicker-to');
        var from    = moment($option.data('from')).toDate();
        var to      = moment($option.data('to')).toDate();

        $from.prop('disabled', $option.data('from') !== undefined);
        $to.prop('disabled', $option.data('to') !== undefined);

        if ($option.data('from') !== undefined) {
            $from.datepicker('setDate', from);
        }

        if ($option.data('to') !== undefined) {
            $to.datepicker('setDate', to);
        }

        this.options.filters.dateRange = this.$('[name=dateRange]').val();
    },

    updateFromDate: function() {
        const fromDate = this.$('.js-datepicker-from').datepicker('getDate');
        const toDate = this.options.filters.to;
        if (fromDate instanceof Date) {
            this.options.filters.from = moment(fromDate).hour(12).toDate();
            // 20200521 for custom date to have range of 1 year only
            if (
                toDate instanceof Date &&
                moment(toDate).diff(fromDate, 'months') > 12 &&
                !this.$('[name=dateRange]').val() // custom date
            ) {
                const newToDate = moment(fromDate).add(1, 'year')
                    .hour(12).toDate();
                this.$('.js-datepicker-to')
                    .datepicker('setDate', newToDate);
                this.$('.js-datepicker-to')
                    .val(moment(newToDate).format('MMMM, YYYY'));
                this.options.filters.to = newToDate;
            }
        } else {
            this.options.filters.from = this.options.fromPeriod;
            this.options.filters.fromFormatted =
                moment(this.options.fromPeriod).format('MMMM, YYYY');
        }
    },

    updateToDate: function() {
        const fromDate = this.$('.js-datepicker-from').datepicker('getDate');
        const toDate = this.$('.js-datepicker-to').datepicker('getDate');
        if (toDate instanceof Date) {
            this.options.filters.to = moment(toDate).hour(12).toDate();
            // 20200521 for custom date to have range of 1 year only
            if (
                fromDate instanceof Date &&
                moment(toDate).diff(fromDate, 'months') > 12 &&
                !this.$('[name=dateRange]').val() // custom date
            ) {
                const newFromDate = moment(toDate).subtract(1, 'year')
                    .hour(12).toDate();
                this.$('.js-datepicker-from')
                    .datepicker('setDate', newFromDate);
                this.$('.js-datepicker-from')
                    .val(moment(newFromDate).format('MMMM, YYYY'));
                this.options.filters.from = newFromDate;
            }
        } else {
            this.options.filters.to = this.options.toPeriod;
            this.options.filters.toFormatted =
                moment(this.options.toPeriod).format('MMMM, YYYY');
        }
    },

    updateGroupBy: function(ev) {
        const $el = this.$(ev.currentTarget);
        this.options.filters.groupBy = $el.val();
        this.getGroupBy();
        this.render();
    },

    getGroupBy: function() {
        if (this.options.filters.groupBy === 'location') {
            this.group = this.options.locations.map(location => ({
                id: location.get('objectId'),
                title: location.get('name'),
            }));
        } else {
            this.group = this.options.employees.map(employee => ({
                id: employee.get('objectId'),
                title: employee.get('fullName'),
            }));
        }
    },

    updateType: function(ev) {
        const $el = this.$(ev.currentTarget);
        this.options.filters.type = $el.val();
    },

    taint: function() {
        this.$('form.filters').addClass('tainted');
    },

    filterIsTainted: function() {
        return this.$('form.filters').hasClass('tainted');
    },

    filter: function(ev) {
        /* Because the stupid datepicker plugin doesn't understand
         * the readonly property as it should I have to use disabled which
         * in turns breaks $.serialize(). Hence, this hacky piece of code
         */
        var fromDate = this.$('.js-datepicker-from').datepicker('getDate');
        var toDate   = this.$('.js-datepicker-to').datepicker('getDate');

        var filters = {
            dateRange: this.$('[name=dateRange]').val(),
            group:  this.$('[name=group]').val(),

            from: fromDate ? moment(fromDate)
                .startOf('month')
                .format('YYYY-MM-DD') : null,
            to: toDate ? moment(toDate)
                .endOf('month')
                .format('YYYY-MM-DD') : null,
            groupBy: this.$('.js-group-by').val(),
            type: this.$('.js-type').val()
        };

        ev.preventDefault();

        if (this.filterIsTainted()) {
            this.$('.js-datepicker-range .form-control').datepicker('hide');
            app.mainRouter.navigate('reports/totals?' + $.param(filters), {
                trigger: true
            });
        }
        this.updateDownloadLink();
    },

    updateDownloadLink: function() {
        const filters = Object.assign({}, this.options.filters);

        filters.from = filters.from ? moment(filters.from)
            .startOf('month')
            .format('YYYY-MM-DD') : null;
        filters.to = filters.to ? moment(filters.to)
            .endOf('month')
            .format('YYYY-MM-DD') : null;

        let employeesFilter = filters['group[]'];
        let locationsFilter = filters['group[]'];
        if (filters.groupBy === 'location') {
            employeesFilter = null;
        } else {
            locationsFilter = null;
        }

        const downloadLink = this.$('#download-link');
        downloadLink.prop('href', Report.downloadUrl({
            companyId:  app.company.id,
            employees: employeesFilter,
            locations: locationsFilter,
            fromDate: filters.from,
            toDate: filters.to
        }));
    },

    remove: function() {
        this.undelegateEvents();
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/reports/EmployeeTotals.js